module.exports = __webpack_public_path__ + "img/logo_1.7d66d85b.jpg";